var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer--overlay"},[_c('div',{staticClass:"footer__top",attrs:{"data-overlay-prevent-close":"true"}},[_c('a',{staticClass:"icon-link",attrs:{"aria-label":"top","href":"#overlay-top"},domProps:{"innerHTML":_vm._s(_vm.svgContent)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }